import { Component, OnInit, OnDestroy } from "@angular/core";
import { GeneralService } from "src/app/services/general.service";
import { CommunicationService } from "src/app/services/communication.service";
import { Observable, Subscription, TimeoutError } from "rxjs";
import {
  Catalogue,
  CataloguePictures,
  CatalogueResponseFromApi
} from "src/app/models/catalogueDescriptor";
import { map } from "rxjs/operators";
import { MockStoreService } from "src/app/services/mock-store.service";
import { CommunicationCommand } from "src/app/models/communicationCommands";
import { MerchantItems } from "src/app/models/items";
import { timeout } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-catalogue",
  templateUrl: "./catalogue.component.html",
  styleUrls: ["./catalogue.component.css"]
})
export class CatalogueComponent implements OnInit, OnDestroy {
  allCataloguesForMerchant: Array<Catalogue> = [];
  cataloguePictures = [...CataloguePictures().data];
  loading: boolean = false;
  count = 54;
  images = [
    { id: "../../../assets/images/Category_pictures/beauty.jpg" },
    { id: "../../../assets/images/Category_pictures/footwear.jpg" },
    { id: "../../../assets/images/Category_pictures/officeEquipment.jpg" },
    { id: "../../../assets/images/Category_pictures/plastics.jpg" },
    { id: "../../../assets/images/Category_pictures/fitnessAndHealth.jpg" },
    { id: "../../../assets/images/Category_pictures/perfumes.jpg" },
    { id: "../../../assets/images/Category_pictures/computers.jpg" },
    { id: "../../../assets/images/Category_pictures/furniture.jpg" },
    { id: "../../../assets/images/Category_pictures/appliances.jpg" }
  ];
  catalogueToModify: Catalogue;
  destroyItems: Array<Subscription> = [];
  constructor(
    private commservice: CommunicationService,
    private generalservice: GeneralService,
    private mockstore: MockStoreService
  ) {}

  ngOnInit(): void {
    this.getCatalogues();

    this.destroyItems[0] = this.generalservice.refresh$.subscribe(val => {
      if (val.length < 1) return;
      if (val.trim() == "refreshCatalogue") {
        this.getCatalogues();
      }
    });

    //  this observer will listen to when the item selected comes back with the
    //  selectedItems into this component
    this.destroyItems[1] = this.generalservice.addItemsFromCatalogueListing$.subscribe(
      val => {
        if (val.length < 1) return;
        if (val["switcher"] == "close" && typeof val["message"] == "object") {
          this.modifyTheItemsInTheCatalogue(
            this.catalogueToModify,
            val["message"]
          );
        } else {
          return;
        }
      }
    );
  }

  //  this function is used for adding, editing a catalogue
  addCatalogue(editStuff?: Catalogue) {
    const command = new CommunicationCommand("edit", editStuff, "catalogue");
    if (editStuff) {
      this.allCataloguesForMerchant = this.removeNulls(
        this.allCataloguesForMerchant
      );
      editStuff.items = editStuff.items.filter(element => element.id !== null);
      this.generalservice.additemNotification(command);
      // console.log(editStuff);
      return;
    }
    this.generalservice.additemNotification("addCatalogue");
  }

  getCatalogues() {
    this.loading = true;
    this.commservice
      .fetchAllCatalogueForMerchant()
      .pipe(map(catalogue => this.modifyCatalogueResponse(catalogue)))
      .subscribe(
        val => {
          // console.log(val);
          this.allCataloguesForMerchant = this.removeNulls(val);
          // console.log(this.allCataloguesForMerchant);
          this.loading = false;
        },
        err => {
          this.loading = false;
          this.allCataloguesForMerchant = [];
          this.generalservice.errorNotification(
            "Could not fetch the requested resource"
          );
        }
      );
  }

  randomNumberGenerator(num: number): number {
    return Math.floor(Math.random() * num);
  }

  //  this is used to modify catalogue before displaying it in the template
  modifyCatalogueResponse(catalogueResponse: CatalogueResponseFromApi) {
    let randomNum = this.randomNumberGenerator(this.cataloguePictures.length);
    catalogueResponse.data.forEach(
      element =>
        (element["catalogue_picture"] = this.cataloguePictures[randomNum])
    );
    // console.log(catalogueResponse.data);
    return catalogueResponse.data;
  }

  // actually deletes a catalogue
  async deleteCatalogue(catalogue: Catalogue) {
    const button = event.srcElement as HTMLLIElement;
    button.classList.remove("fa fa-trash-alt");
    button.classList.add("fa fa-circle-notch fa-spin");
    try {
      const response = await this.commservice.removeCatalogue(
        catalogue.id.toString()
      );
      const { message } = response;
      this.allCataloguesForMerchant = this.allCataloguesForMerchant.filter(
        anItem => anItem.id != catalogue.id
      );
      this.generalservice.successNotification(message);
    } catch (error) {
      console.log(error);
    }

    button.classList.remove("fa fa-circle-notch fa-spin");
    button.classList.add("fa fa-trash-alt");
  }
  // this function will slide the div right
  slideRight(sliderContainer) {
    const div = document.getElementById(sliderContainer) as HTMLDivElement;
    div.style.transform = `translateX(-${this.count}px)`;
    this.count += 55;
  }

  //  this function will slide the div left
  slideLeft(sliderContainer) {
    if (this.count < 1) {
      this.count = 54;
    }
    this.count -= 55;
    const div = document.getElementById(sliderContainer) as HTMLDivElement;
    div.style.transform = `translateX(-${this.count}px)`;
  }

  viewCatalogue(catalogue: Catalogue) {
    let comm = new CommunicationCommand("view", catalogue, "catalogue");
    this.generalservice.additemNotification(comm);
  }

  //strip nulls off. For some crazy reason i cant figure out yet, nulls are being added to
  // the items property of a catalogue;
  removeNulls(arr: Catalogue[]) {
    for (let element of arr) {
      let temp = [];
      temp = [...element.items];
      element.items.splice(0, element.items.length);
      element.items = temp.filter(elem => typeof elem.id == "number");
    }
    // console.log(arr);
    return arr;
  }

  getRemainingItems(catalogue: Catalogue) {
    return catalogue.items.length == 10
      ? `add 10 more items to this catalogue`
      : `add ${10 - catalogue.items.length} more items to this catalogue`;
  }

  addMoreItemsToCatalogue(catalogue: Catalogue) {
    this.mockstore.addingDirectlyFromCatalogueListing =
      10 - catalogue.items.length;
    this.mockstore.comingFromCatalogueListingComponent = true;
    this.generalservice.startFetchingSelectionItems("start");
    this.generalservice.broadCastMessageToAddItemsDirectlyToCatalogueListing({
      switcher: "open",
      message: "ItemsSelectionViewComponent"
    });
    this.catalogueToModify = catalogue;
  }

  modifyTheItemsInTheCatalogue(catalogue: Catalogue, item: MerchantItems[]) {
    if (!window.navigator.onLine) {
      this.catalogueToModify = undefined;
      this.generalservice.warningNotification(
        "Please check you internet connection and try again"
      );
      return;
    }
    const temp = [...catalogue.items, ...item];
    let catalogue_item_ids = temp.map(element => element.id);
    let formToSubmit = {
      name: catalogue.name,
      description: catalogue.description,
      catalogue_item_ids
    };

    this.commservice
      .editACatalogue(formToSubmit, catalogue.id)
      .pipe(timeout(50000))
      .subscribe(
        val => {
          const { message } = val;
          this.generalservice.successNotification(message);
          this.getCatalogues();
        },
        err => {
          if (err instanceof TimeoutError) {
            this.catalogueToModify = undefined;
            this.generalservice.warningNotification(
              "It seems you have bad internet. Please try again"
            );
            return;
          }

          if (err instanceof HttpErrorResponse) {
            this.catalogueToModify = undefined;
            this.generalservice.warningNotification(
              "Could not add to the items currently. Please try again later"
            );
            return;
          }
        }
      );
  }

  ngOnDestroy() {
    this.destroyItems.forEach(element => {
      if (element != undefined) element.unsubscribe();
    });
  }
}
